export default {
  namespaced: true,

  state: {
    title: '',
  },

  mutations: {
    title(state, value) {
      state.title = value;
    },
  },
};
